import account from "./account";
import basket from "./basket";
import brand from "./brand";
import bulkAction from "./bulkAction";
import client from "./client";
import clientCompany from "./clientCompany";
import clientEmail from "./clientEmail";
import clientPaymentDetails from "./clientPaymentDetails";
import clientPhone from "./clientPhone";
import contract from "./contract";
import contractProduct from "./contractProduct";
import cost from "./cost";
import creditDebitTransaction from "./creditDebitTransaction";
import csv from "./csv";
import customFieldValue from "./customFieldValue";
import gateway from "./gateway";
import invoice from "./invoice";
import oauth from "./oauth";
import organisation from "./organisation";
import paymentReconciliation from "./paymentReconciliation";
import pricelist from "./pricelist";
import product from "./product";
import productGroup from "./productGroup";
import promotion from "./promotion";
import provisionRequest from "./provisionRequest";
import provisionResult from "./provisionResult";
import template from "./template";
import ticket from "./ticket";
import ticketMessage from "./ticketMessage";
import upmindPayAccount from "./upmindPayAccount";
import user from "./user";
import vault from "./vault";
import voucher from "./voucher";
import wallet from "./wallet";

export const HookLogEventsMap = {
  ...account,
  ...basket,
  ...brand,
  ...bulkAction,
  ...client,
  ...clientCompany,
  ...clientEmail,
  ...clientPaymentDetails,
  ...clientPhone,
  ...contract,
  ...contractProduct,
  ...cost,
  ...creditDebitTransaction,
  ...csv,
  ...customFieldValue,
  ...gateway,
  ...invoice,
  ...oauth,
  ...organisation,
  ...paymentReconciliation,
  ...pricelist,
  ...product,
  ...productGroup,
  ...promotion,
  ...provisionRequest,
  ...provisionResult,
  ...template,
  ...ticket,
  ...ticketMessage,
  ...upmindPayAccount,
  ...user,
  ...vault,
  ...voucher,
  ...wallet
};

export default HookLogEventsMap;
